var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSweatLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.884.154A2.885 2.885 0 0028 3.038v14.424H17.038a2.885 2.885 0 00-2.885 2.884V34.77H3.192a2.885 2.885 0 00-2.885 2.885V51.5a2.885 2.885 0 002.885 2.885h10.961v14.423a2.885 2.885 0 002.885 2.884H28v14.423A2.885 2.885 0 0030.884 89H44.73a2.885 2.885 0 002.885-2.885v-31.73H97.23v31.73A2.885 2.885 0 00100.115 89h13.846a2.885 2.885 0 002.885-2.885V71.692h10.961a2.885 2.885 0 002.885-2.884V54.385h10.961a2.884 2.884 0 002.885-2.885V37.654a2.884 2.884 0 00-2.885-2.885h-10.961V20.346a2.885 2.885 0 00-2.885-2.884h-10.961V3.038a2.885 2.885 0 00-2.885-2.884h-13.846a2.885 2.885 0 00-2.885 2.884V34.77H47.615V3.04A2.885 2.885 0 0044.73.153H30.884zm-16.73 48.461v-8.077H6.075v8.077h8.077zm5.769 17.308H28V23.231h-8.077v42.692zm105 0h-8.077V23.231h8.077v42.692zm13.846-17.308h-8.077v-8.077h8.077v8.077zm-105 34.616h8.077V5.923h-8.077v77.308zm77.307 0H103V5.923h8.076v77.308zM47.615 40.539v8.076H97.23v-8.077H47.615z",
    fill: "#04B7D6"
  })));
}

export default SvgSweatLogo;